import * as setup from '@/setup';
export default class Counter extends Phaser.GameObjects.Container {
	/**
   *  My custom dynamic counter.
   *
   *  @constructor
   *  @class Counter
   *  @extends Phaser.GameObjects.Container
   *  @param {Phaser.Scene} scene - The scene that owns this bitmap text.
   *  @param {number} x - The horizontal coordinate relative to the scene viewport.
   *  @param {number} y - The vertical coordinate relative to the scene viewport.
   *  @param {string} icon - image key.
   *  @param {string} label - The label of the text.
   * 
   */
	constructor(scene, x, y, icon, label) {
		super(scene, x, y);

		//var container = this.add.container(x, y);
		var ball = scene.add.image(0, 0, icon);
		var text = scene.add.text(0, 0, label, setup.styles.counterStyle).setOrigin(0, 0.5);
		text.setShadow(1, 1, '#000000', 2, true, true);
		this.add(ball);
		this.add(text);
		// initializza l'animazione al centro del counter in caso di variazione del counter. Adesso non è visibile
		this.auxTextObj = scene.add.text(x, y, 0, setup.styles.leapStyle).setOrigin(0, 0.5).setAlpha(0);

		//  Add this game object to the owner scene.
		scene.children.add(this, x, y);
	}

	update(label) {
		//console.log(this);
		this.list[1].setText(this.pad(label, 3));
	}

	pad(string, size) {
		var s = String(string);
		while (s.length < (size || 2)) {
			s = '0' + s;
		}
		return s;
	}

	textLeapAnimation(label) {
		if (label.toString().charAt(0) === '+') this.auxTextObj.setColor(setup.colors.leapStyleFillColor.win);
		else this.auxTextObj.setColor(setup.colors.leapStyleFillColor.lost);
		// posiziono la lettera al centro del rettangolo del container
		this.auxTextObj.x = this.getBounds().x + this.getBounds().width / 2;
		this.auxTextObj.y = this.getBounds().y - 90;
		this.auxTextObj.depth = 1;
		this.auxTextObj.setText(label).setAlpha(0.7);
		// fa uscire l'animazione a dx o sx dello schermo
		//var x = -50;
		//if (this.getBounds().x < config.width / 2) x = config.width + 50;
		// animazione che porta le lettera fuori dall'asse delle x
		this.leapAnimation = this.scene.tweens.add(
			{
				targets: this.auxTextObj,
				x: this.getBounds().x + this.getBounds().width / 2,
				y: this.getBounds().y + this.getBounds().height / 4,
				ease: 'Power1',
				duration: 1500,
				delay: 0,
				yoyo: false,
				repeat: 0,
				onComplete: function(tween, target, self) {
					//console.log(target, self);
					self.auxTextObj.setAlpha(0);
				},
				onCompleteParams: [ this ]
			},
			this
		);
	}
}
